//Core
import {FC} from "react";
//Providers
import {BrowserRouter} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import {Provider} from "react-redux";
import {Auth0Provider} from "@auth0/auth0-react";
import {SnackbarProvider} from "notistack";
//Theme
import theme from "./styles/theme/theme";
//Redux
import {store} from "./redux/store";
//Components
import Main from "./components/layout/main/Main";
//Utils
import ScrollToTop from "./components/layout/utils/ScrollToTop";
//Styles
import { CssBaseline } from "@mui/material";

const App: FC = () => {
    // const redirectUri = () => {
    //     if (typeof window !== 'undefined') {
    //         return window.location.origin
    //     }
    // }
    //
    // const onRedirectCallback = (appState: any) => {
    //     window.location.replace(appState?.returnTo || window?.location?.pathname);
    // };

    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <SnackbarProvider
                        maxSnack={2}
                        hideIconVariant
                        autoHideDuration={5000}
                        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                        preventDuplicate
                        style={{fontSize: "1.4rem"}}
                    >
                        <Auth0Provider
                            domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
                            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
                            audience={process.env.REACT_APP_AUTH0_AUDIENCE as string}
                            scope={"read:current_user update:current_user_metadata offline_access"}
                            useRefreshTokens
                            redirectUri={window.location.origin}
                            // onRedirectCallback={onRedirectCallback}
                            // authorizationParams={{
                            //     audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
                            //     redirect_uri: window.location.origin,
                            //     scope: "read:current_user update:current_user_metadata",
                            //     refresh_token: true,
                            // }}
                        >
                            <ScrollToTop>
                                <Main/>
                                <CssBaseline/>
                            </ScrollToTop>
                        </Auth0Provider>
                    </SnackbarProvider>
                </Provider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
